import {fetchAuthSession} from "aws-amplify/auth"

export default async function currentAuthSession() {
    try {
        const {accessToken, idToken} = (await fetchAuthSession()).tokens ?? {}
        return {accessToken, idToken}
    } catch (error) {
        console.error("currentAuthSession: ", error)
    }
}